import { render, staticRenderFns } from "./unitList.vue?vue&type=template&id=58bbc674&"
import script from "./unitList.vue?vue&type=script&lang=js&"
export * from "./unitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports